/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const columns = 6;
const rows = 8;
const iconButtonSize = '42px';

export default $ => css`
  .select-image-field {
    .dropdown-menu {
      max-width: none;
      position: relative;
      margin-top: 44px;

      > .list-tabs {
        position: absolute;
        left: -1px;
        top: -42px;
        background-color: ${$.dropdownBg};
        padding: 5px 6px 0px 6px;
        border: 1px solid ${$.dropdownBorderColor};
        border-radius: 5px 5px 0px 0px;
        border-bottom-width: 0;
      }
      > .button-list {
        display: grid;
        grid-template-columns: repeat(${columns}, ${iconButtonSize});
        max-height: calc(${iconButtonSize} * ${rows});
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0 6px;

        > button {
          position: relative;
          > .idx {
            position: absolute;
            top: 0;
            left: 0;
            font-size: 0.6rem;
            white-space: nowrap;
            text-shadow: 0px 0px 2px #fff, 0px 0px 2px #fff, 0px 0px 2px #fff;
          }
        }
      }
    }
  }
`;
